import { Grid, Box, Typography } from '@mui/material'

export interface EventTitleProps {
  title: string
}

export const EventTitle: React.FC<EventTitleProps> = ({ title }) => {
  return (
    <Grid item sm={12} sx={{}}>
      <Typography
        align='left'
        color='#79747E'
        sx={{
          fontSize: {
            lg: '48px !important',
            md: '40px !important',
            sm: '32px !important',
            xs: '32px !important'
          },
          fontWeight: { lg: '400', md: '450px', sm: '500', xs: '500' },
          lineHeight: { lg: '56.25px', md: '48px', sm: '37px', xs: '37px' },
          letter: '-2%',
          pt: { lg: '48px', md: '42px', sm: '36px', xs: '36px' },
          pb: { lg: '32px', md: '28px', sm: '24px', xs: '24px' }
          // display: { md: 'none' }
        }}
      >
        {title}
      </Typography>
    </Grid>
  )
}
